import { Location } from '@angular/common';
import { element } from 'protractor';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, ɵConsole } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
})
export class LoginFormComponent implements OnInit {
  @Input() esModal: boolean = false;
  @Output() resultEvent = new EventEmitter<any>();
  @Output() goRegister = new EventEmitter<any>();

  loginForm: FormGroup;
  cargando = false;
  verPassword = false;

  constructor(private auth: AuthService, private router: Router, private location: Location) {
    // Formulario
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    // if (!this.esModal) this.auth.estaAutenticado('/');
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.cargando = true;

      let email = this.loginForm.controls.email.value;
      let password = this.loginForm.controls.password.value;

      this.auth.login(email, password).then((resp) => {
        this.cargando = false;
        this.resultEvent.emit(resp);
      });
    }
  }

  register() {
    if (!this.esModal) {
      this.router.navigateByUrl('/registro');
    }

    this.goRegister.emit('/registro');
  }

  back() {
    this.location.back();
  }

  alternarVerPassword(idElement: string = null) {
    if (idElement) {
      let propiedad = 'ver' + idElement.charAt(0).toUpperCase() + idElement.slice(1);

      this[propiedad] = !this[propiedad];
      let elemento: any = document.getElementById(idElement);

      if (elemento) {
        elemento.type = this[propiedad] ? 'text' : 'password';
      }
    }
  }
}
